export default {"src":"/_next/static/media/hero-bg.0a512676.svg","height":665,"width":1377,"blurWidth":0,"blurHeight":0};